import BaseReportPDFPreviewLightbox from "../pdf/PDFPreviewLightbox"
import PDFPreviewLightboxController from "./PDFPreviewLightboxController"

const PDFPreviewLightbox = function() {};

PDFPreviewLightbox.prototype = _.create(BaseReportPDFPreviewLightbox.prototype, {

    createPDFLightboxController: function({lightBoxEl, titleEl, popupId, eventNamespace}) {
        return new PDFPreviewLightboxController().init({
            lightBoxEl: lightBoxEl,
            titleEl: titleEl,
            popupId: popupId,
            eventNamespace: eventNamespace,
            productSettingsValidator: new ATProductSettingsValidator(),
            reportRightsValidator: new ATReportRightsValidator(),
        })
    }
})

export default PDFPreviewLightbox


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/PDFPreviewLightbox.js